require('../modules/web.timers');
module.exports = require('../modules/_core');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/web/timers.js
// module id = 698
// module chunks = 130